import { render, staticRenderFns } from "./ShowExpand.vue?vue&type=template&id=1dd50360"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports